"use client";

import { ReactNode, useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

interface ParallaxLayerProps {
    children: ReactNode;
    speed?: number; // -1 to 1; positive = slower, negative = faster
    className?: string;
    fade?: boolean; // fade edges when entering/leaving viewport
}

export function ParallaxLayer({
    children,
    speed = 0.3,
    className,
    fade = false,
}: ParallaxLayerProps) {
    const ref = useRef<HTMLDivElement>(null);

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });

    const rawY = useTransform(scrollYProgress, [0, 1], [speed * 120, speed * -120]);
    const y = useSpring(rawY, { stiffness: 100, damping: 30, restDelta: 0.001 });

    const opacity = useTransform(scrollYProgress, [0, 0.15, 0.85, 1], [0, 1, 1, 0]);
    const smoothOpacity = useSpring(opacity, { stiffness: 100, damping: 30 });

    return (
        <motion.div
            ref={ref}
            style={{
                y,
                ...(fade ? { opacity: smoothOpacity } : {}),
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
